import { createStyles } from "@mantine/core";

export default createStyles ( theme => {

	return {
		container: {
			overflow : "auto",
			display  : "flex",
			// justifyContent : "space-evenly",
			margin   : "0 1rem",
			padding  : "1rem 0"
		},
		button: {
			margin        : "1rem 0.5rem",
			padding       : "0",
			textTransform : "none !important",
			borderRadius  : "1rem !important",
			height        : "35px",
			flex          : "1"
		},
		textStyles: {
			fontSize     : "1.5rem !important",
			overflow     : "hidden",
			textOverflow : "ellipsis",
			whiteSpace   : "nowrap",
			color        : theme.other.colors.text.primary,
			fontWeight   : "500"
		},
		textStylesActive: {
		}
	};
} );

